export const removeAccents = (str: string) =>
    str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

export const toCamelCase = <T extends string>(str?: string): T => {
    if (!str) return '' as unknown as T
    return removeAccents(str)
        .replace(/[^a-zA-Z0-9]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
        .replace(/^(.)/, (match) => match.toLowerCase()) as unknown as T
}

export const fromCamelCase = (str?: string): string => {
    if (!str) return ''
    return str.replace(/([a-z])([A-Z])/g, '$1 $2')
}

export const toPascalCase = <T extends string>(str?: string): T => {
    if (!str) return '' as unknown as T
    return removeAccents(str)
        .replace(/[^a-zA-Z0-9]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
        .replace(/^(.)/, (match) => match.toUpperCase()) as unknown as T
}

export const toKebabCase = <T extends string>(str?: string): T => {
    if (!str) return '' as unknown as T
    return removeAccents(str)
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/[^a-zA-Z0-9]+/g, '-')
        .toLowerCase() as unknown as T
}

export const fromKebabCase = (str?: string): string => {
    if (!str) return ''
    return str.replace(/-/g, ' ')
}

export const toSnakeCase = <T extends string>(str?: string): T => {
    if (!str) return '' as unknown as T
    return removeAccents(str)
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .replace(/[^a-zA-Z0-9]+/g, '_')
        .toLowerCase() as unknown as T
}

export const capitalizeFirstLetter = (str?: string) => {
    if (!str) return ''
    return str.charAt(0).toUpperCase() + str.slice(1)
}

export const lowercaseFirstLetter = (str?: string) => {
    if (!str) return ''
    return str.charAt(0).toLowerCase() + str.slice(1)
}
